// extracted by mini-css-extract-plugin
module.exports = {"forgot":"LoginTab_forgot_2HTxK","loginlink":"LoginTab_loginlink_s56tb","googletip":"LoginTab_googletip_3BFUS"};